import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useLayoutEffect, useRef } from 'react';
import Box from '../Box';
import Scrim from '../Scrim';
import { useDocumentEvent } from '../hooks';
import { trapFocus } from '../utils';

function Modal(_ref) {
  var children = _ref.children,
      closeOnOutsideClick = _ref.closeOnOutsideClick,
      onRequestClose = _ref.onRequestClose,
      open = _ref.open,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "closeOnOutsideClick", "onRequestClose", "open"]);

  var modalRef = useRef(null);
  useLayoutEffect(function () {
    if (open) {
      return trapFocus(modalRef.current);
    }
  }, [open]);
  useDocumentEvent('keydown', function (event) {
    if (open && onRequestClose && event.keyCode === 27) {
      onRequestClose();
    }
  });

  if (!open) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Scrim, {
    alignment: "center",
    onMouseDown: function onMouseDown(event) {
      if (closeOnOutsideClick && event.currentTarget === event.target) {
        onRequestClose();
      }
    }
  }, /*#__PURE__*/React.createElement(Box, _extends({
    innerRef: modalRef,
    width: "100%",
    maxWidth: 60,
    padding: 2,
    margin: 4,
    backgroundColor: "surface",
    radius: 3
  }, restProps), children));
}

export default Modal;